export default "__VITE_ASSET__DEZunW7C__"